export interface SetWidgetConfigIdAction {
  type: "SET_WIDGET_CONFIG_ID";
  data: string;
}

export function setWidgetConfigId(
  widgetConfigId: string
): SetWidgetConfigIdAction {
  return {
    type: "SET_WIDGET_CONFIG_ID",
    data: widgetConfigId,
  };
}
